import React, { Suspense } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import DesktopIndex from './DesktopIndex';
import MobileIndex from './MobileIndex';

const Index = () => {
  const isMobile = useIsMobile();

  return (
    <Suspense fallback={null}>
      {isMobile ? <MobileIndex /> : <DesktopIndex />}
    </Suspense>
  );
};

export default Index;